module.exports = __webpack_public_path__ + "static/media/badge-not-earned.7bc569f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badge-not-earned.svg
// module id = 1642
// module chunks = 0